import { create } from 'zustand';

import {
  readStoredLogosLabelsFilter,
  writeStoredLogosLabelsFilter,
} from '@/features/logos/utils/labels-filter-storage';

type LogosLabelsFilterState = {
  labels: string[];
  setLabels: (labels: string[]) => void;
};

/**
 * Single source of truth for the Logos "labels" filter.
 *
 * Several UIs let the user pick label filters for logos (the toolkit Add/Logos
 * panel, the mentions filter bar and the presences datatable). They all share
 * the same selection, persisted in localStorage. Centralising it here keeps
 * every writer and reader (e.g. the toolkit badge) in sync reactively, without
 * needing a manual refresh.
 */
export const useLogosLabelsFilterStore = create<LogosLabelsFilterState>(set => ({
  labels: readStoredLogosLabelsFilter(),
  setLabels: labels => {
    writeStoredLogosLabelsFilter(labels);
    set({ labels });
  },
}));
